import React from "react";
import Nav from './Nav2';
import Footer from './Footer';
import { Outlet } from "react-router-dom";

const Layout = () => {

	return (
		<div className="flex flex-col items-center bg-zinc-950">
			<Nav />
			<Outlet />
			<Footer />
		</div>
	)
}

export default Layout